import 'windi.css'
import SceneConfigureRoutes from './routes'

export default {
  // name version 必须为字面常量
  name: 'scene-configure',
  title: '场景配置',
  version: '0.1.33',
  description: '三维场景配置',
  routes: SceneConfigureRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['DirectoryApi', 'MaterialApi', 'FileApi', 'ModelSceneApi'],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
